class CommerceProductMatrixTV {
    constructor() {
        this.tvs = document.querySelectorAll('.commerce-productmatrix-container');

        for (let i = 0; i < this.tvs.length; i++) {
            this.initTV(this.tvs[i]);
        }
    }

    initTV(dom) {
        let valueField = dom.querySelector('.commerce-productmatrix-value'),
            matrixId = valueField.value,
            productTable = dom.querySelector('.commerce-productmatrix'),
            productTableBody = productTable.querySelector('tbody'),
            tableWrapper = dom.querySelector('.commerce-productmatrix-wrapper'),
            invalidOverlay = dom.querySelector('.commerce-productmatrix-invalid__overlay');

        setInterval(refreshMatrixTable, 60000);

        dom.addEventListener('click', function (e) {
            let target = e.target.nodeName === 'A' ? e.target : e.target.parentNode;
            if (target.matches('.cpmi-modal-link-with-refresh')) {
                if (e.ctrlKey || e.metaKey) {
                    return true;
                }
                e.preventDefault();
                let opts = {};
                opts.successCallback = function (data) {
                    if (data.success) {
                        refreshMatrixTable();
                        return true;
                    }
                };
                Commerce.Modal.loadLinkModal.bind(Commerce.Modal)(target.getAttribute('href'), '', opts);
            }

            else if (target.matches('.commerce-productmatrix-invalid__new')
                || target.matches('.commerce-productmatrix-invalid__duplicate')
                || target.matches('.commerce-productmatrix-invalid__reassign')) {
                e.preventDefault();
                let opts = {};
                opts.successCallback = function (data) {
                    if (!data.record.id) {
                        return false;
                    }

                    let oldId = valueField.value;
                    valueField.value = matrixId = data.record.id;

                    refreshMatrixTable(removeInvalidOverlay);

                    let btns = dom.querySelectorAll('.commerce-productmatrix-toolbar a');
                    btns.forEach(function (btn) {
                        btn.href = btn.href.replace('&id=' + oldId, '&id=' + matrixId);
                    });

                    // Mark dirty so user is prompted to save the resource
                    Ext.getCmp('modx-panel-resource').markDirty();

                    return true;
                };
                Commerce.Modal.loadLinkModal.bind(Commerce.Modal)(target.getAttribute('href'), '', opts);
            }
        });

        /**
         * Update the product information for a specific product over AJAX.
         */
        function refreshMatrixTable(callback) {
            Commerce.Request.get(Commerce.Config.connector_url + '?action=mgr/tvs/matrix/render&matrix=' + matrixId, {
                onSuccess: function (response) {
                    let responseDom = document.createElement('div');
                    responseDom.innerHTML = response;

                    productTable.innerHTML = responseDom.firstChild.innerHTML;
                    productTableBody = productTable.querySelector('tbody');

                    if (callback) {
                        callback(response);
                    }
                }
            });
        }

        function removeInvalidOverlay() {
            tableWrapper.classList.remove('commerce-productmatrix-invalid__matrix');
            if (invalidOverlay && invalidOverlay.parentNode) {
                invalidOverlay.parentNode.removeChild(invalidOverlay);
                invalidOverlay = null;
            }
        }
    }
}
